import { Link } from "react-router-dom";
import type { WebOrdersReport } from "../../../api/types";
import { euro } from "../../finances/opcostFormat";
import { personLink } from "./reportLinks";
import { minutesText } from "./webOrdersText";

/**
 * G-143 — who did the work: accepted, built, handed over. The money is the
 * money of their own hand-overs (OD-221), commission included (OD-219).
 */
export function PeopleTable({ report, query }: { report: WebOrdersReport; query: URLSearchParams }) {
  return (
    <div className="table-scroll">
      <table className="wo-table">
        <thead>
          <tr>
            <th>Person</th>
            <th>Shop</th>
            <th className="wo-num">Accepted</th>
            <th className="wo-num">Bouquets built</th>
            <th className="wo-num">Handed over</th>
            <th className="wo-num">Booked</th>
            <th className="wo-num">Commission</th>
          </tr>
        </thead>
        <tbody>
          {report.people.map((p) => (
            <tr key={p.person.id}>
              <td className="wo-cell-title">
                <Link to={personLink(p.person.id, query)}>{p.person.fullName}</Link>
              </td>
              <td data-label="Shop">{p.shopNames.join(", ") || "—"}</td>
              <td className="wo-num" data-label="Accepted">{p.accepted}</td>
              <td className="wo-num" data-label="Bouquets built">{p.bouquetsBuilt}</td>
              <td className="wo-num" data-label="Handed over">{p.handedOver}</td>
              <td className="wo-num" data-label="Booked">{euro(p.money.bookedEur)}</td>
              <td className="wo-num" data-label="Commission">{euro(p.money.commissionEur)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** G-143 — the couriers who carried the period's web orders. */
export function CouriersTable({ report, query }: { report: WebOrdersReport; query: URLSearchParams }) {
  return (
    <div className="table-scroll">
      <table className="wo-table">
        <thead>
          <tr>
            <th>Courier</th>
            <th className="wo-num">Delivered</th>
            <th className="wo-num">Out now</th>
            <th className="wo-num">Could not deliver</th>
            <th className="wo-num">Pickup to door</th>
            <th className="wo-num">Courier payout</th>
          </tr>
        </thead>
        <tbody>
          {report.couriers.map((c) => (
            <tr key={c.courier.id}>
              <td className="wo-cell-title">
                <Link to={personLink(c.courier.id, query)}>{c.courier.fullName}</Link>
              </td>
              <td className="wo-num" data-label="Delivered">{c.delivered}</td>
              <td className="wo-num" data-label="Out now">{c.outNow}</td>
              <td className="wo-num" data-label="Could not deliver">{c.failed}</td>
              <td className="wo-num" data-label="Pickup to door">{minutesText(c.averageMinutesPickupToDoor)}</td>
              <td className="wo-num" data-label="Courier payout">{euro(c.payEur)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
